import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import ToolExecutionCard from './ToolExecutionCard';

function ChatMessage({ message }) {
    const isUser = message.role === 'user';

    return (
        <div className={`chat-message ${isUser ? 'chat-message-user' : 'chat-message-assistant'}`}>
            <div className="chat-message-avatar">
                {isUser ? '\uD83D\uDC64' : '\uD83E\uDD16'}
            </div>
            <div className="chat-message-content">
                {message.toolExecutions && message.toolExecutions.length > 0 && (
                    <div className="chat-tool-executions">
                        {message.toolExecutions.map((exec, i) => (
                            <ToolExecutionCard key={i} execution={exec} />
                        ))}
                    </div>
                )}
                <div className="chat-message-text">
                    {isUser ? (
                        <p>{message.content}</p>
                    ) : (
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {message.content}
                        </ReactMarkdown>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ChatMessage;
